import * as THREE from 'three';
export default class lights {

    constructor(scene) {
        this.scene = scene
        this.createLights()
    }

    createLights() {
        const positions = [{ x: 0, y: 60, z: 50, target: { x: 0, y: 0, z: 0 } }, { x: -100, y: 60, z: 150, target: { x: -100, y: 0, z: 100 } }, { x: -100, y: 60, z: -50, target: { x: -100, y: 0, z: -100 } }]

        const ambientLight = new THREE.AmbientLight(0xffffff, 0.25);
        const hemiLight = new THREE.HemisphereLight(0xffffbb, 0x080820, .25);

        this.ambientLight = ambientLight
        this.hemiLight = hemiLight
        
        this.scene.add(ambientLight)
        this.scene.add(hemiLight)

        for (const position of positions) {
            const targetObject = new THREE.Object3D();
            targetObject.position.set(position.target.x, position.target.y, position.target.z)


            const light = new THREE.DirectionalLight(0xffffff, 0.25);
            light.position.set(position.x, position.y, position.z);

            light.castShadow = true;
            light.shadow.mapSize.width = 2048 / 2 // default
            light.shadow.mapSize.height = 2048 / 2; // default
            light.distance = 70;
            light.target = targetObject;

            // const helper = new THREE.CameraHelper(light.shadow.camera);

            // this.scene.add(helper);
            this.scene.add(light)
            this.scene.add(targetObject);
        }
    }
}